export default __webpack_public_path__ + "static/media/ies.b027b7d4.png";